import { axiosService } from "../axios.service";
import { urls } from "../../constants";

const settingsService = {
    getSettings: () => axiosService.get(urls.settings.appSettings).then(v => v.data),
    updateSettings: (data) => axiosService.patch(urls.settings.appSettings, data).then(v => v.data),
};

export { settingsService };
